"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscolaLMSContextProvider = exports.sortProgram = exports.getDefaultData = exports.EscolaLMSContext = exports.SCORMPlayer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var courses_1 = require("./courses");
var states_1 = require("./states");
var courses_2 = require("./../../services/courses");
var consultations_1 = require("./../../services/consultations");
var products_1 = require("../../services/products");
var webinars_1 = require("../../services/webinars");
var events_1 = require("../../services/events");
var settings_1 = require("./../../services/settings");
var notify_1 = require("../../services/notify");
var certificates_1 = require("../../services/certificates");
var mattermost_1 = require("../../services/mattermost");
var cart_1 = require("./../../services/cart");
var user_groups_1 = require("./../../services/user_groups");
var useLocalStorage_1 = require("../hooks/useLocalStorage");
var defaults_1 = require("./defaults");
var fields_1 = require("../../services/fields");
var questionnaire_1 = require("../../services/questionnaire");
var stationary_events_1 = require("../../services/stationary_events");
var courses_3 = require("./courses");
var categories_1 = require("./categories");
var tags_1 = require("./tags");
var tutors_1 = require("./tutors");
var webinars_2 = require("./webinars");
var webinar_1 = require("./webinar");
var h5p_1 = require("./h5p");
var pages_1 = require("./pages");
var page_1 = require("./page");
var consultations_2 = require("./consultations");
var user_1 = require("./user");
var SCORMPlayer = function (_a) {
    var uuid = _a.uuid;
    var apiUrl = (0, react_1.useContext)(exports.EscolaLMSContext).apiUrl;
    return (0, jsx_runtime_1.jsx)("iframe", { src: "".concat(apiUrl, "/api/scorm/play/").concat(uuid) });
};
exports.SCORMPlayer = SCORMPlayer;
exports.EscolaLMSContext = react_1.default.createContext(defaults_1.defaultConfig);
var getDefaultData = function (key, initialValues) {
    return initialValues[key];
};
exports.getDefaultData = getDefaultData;
var sortProgram = function (lessons) {
    return __spreadArray([], lessons, true).sort(function (lessonA, lessonB) {
        return typeof lessonA.order === "number" && typeof lessonB.order === "number"
            ? lessonA.order - lessonB.order
            : 0;
    })
        .map(function (lesson) { return (__assign(__assign({}, lesson), { topics: __spreadArray([], (lesson.topics || []), true).sort(function (topicA, topicB) {
            return typeof topicA.order === "number" && typeof topicB.order === "number"
                ? topicA.order - topicB.order
                : 0;
        }) })); });
};
exports.sortProgram = sortProgram;
/**
 *
 * @component
 */
var EscolaLMSContextProviderInner = function (_a) {
    var children = _a.children, apiUrl = _a.apiUrl, defaults = _a.defaults, _b = _a.imagePrefix, imagePrefix = _b === void 0 ? "".concat(apiUrl, "/storage/imgcache") : _b, _c = _a.initialFetch, initialFetch = _c === void 0 ? true : _c;
    // interceptors(apiUrl);
    var initialValues = __assign(__assign({}, defaults_1.defaultConfig), defaults);
    var getImagePrefix = function () { return imagePrefix; };
    var _d = (0, react_1.useContext)(user_1.UserContext), token = _d.token, user = _d.user, socialAuthorize = _d.socialAuthorize, changePassword = _d.changePassword, login = _d.login, logoutUser = _d.logout, forgot = _d.forgot, reset = _d.reset, fetchProfile = _d.fetchProfile, updateProfile = _d.updateProfile, updateAvatar = _d.updateAvatar, getRefreshedToken = _d.getRefreshedToken, emailVerify = _d.emailVerify, tokenExpireDate = _d.tokenExpireDate, register = _d.register;
    var _e = (0, react_1.useContext)(courses_1.CoursesContext), courses = _e.courses, fetchCourses = _e.fetchCourses;
    var _f = (0, react_1.useContext)(categories_1.CategoriesContext), categoryTree = _f.categoryTree, fetchCategories = _f.fetchCategories;
    var _g = (0, react_1.useContext)(tags_1.TagsContext), uniqueTags = _g.uniqueTags, fetchTags = _g.fetchTags;
    var _h = (0, react_1.useContext)(tutors_1.TutorsContext), tutors = _h.tutors, fetchTutors = _h.fetchTutors;
    var _j = (0, react_1.useContext)(webinars_2.WebinarsContext), webinars = _j.webinars, fetchWebinars = _j.fetchWebinars;
    var _k = (0, react_1.useContext)(webinar_1.WebinarContext), webinar = _k.webinar, fetchWebinar = _k.fetchWebinar;
    var _l = (0, react_1.useContext)(h5p_1.H5pContext), h5p = _l.h5p, fetchH5P = _l.fetchH5P;
    var _m = (0, react_1.useContext)(consultations_2.ConsultationsContext), consultations = _m.consultations, fetchConsultations = _m.fetchConsultations;
    var _o = (0, react_1.useContext)(pages_1.PagesContext), pages = _o.pages, fetchPages = _o.fetchPages;
    var _p = (0, react_1.useContext)(page_1.PageContext), page = _p.page, fetchPage = _p.fetchPage;
    var _q = (0, useLocalStorage_1.useLocalStorage)("lms", "consultation", (0, exports.getDefaultData)("consultation", initialValues)), consultation = _q[0], setConsultation = _q[1];
    var _r = (0, useLocalStorage_1.useLocalStorage)("lms", "userConsultations", (0, exports.getDefaultData)("userConsultations", initialValues)), userConsultations = _r[0], setUserConsultations = _r[1];
    var _s = (0, useLocalStorage_1.useLocalStorage)("lms", "tutorConsultations", (0, exports.getDefaultData)("tutorConsultations", initialValues)), tutorConsultations = _s[0], setTutorConsultations = _s[1];
    var _t = (0, useLocalStorage_1.useLocalStorage)("lms", "events", (0, exports.getDefaultData)("events", initialValues)), events = _t[0], setEvents = _t[1];
    var _u = (0, useLocalStorage_1.useLocalStorage)("lms", "userGroup", (0, exports.getDefaultData)("userGroup", initialValues)), userGroup = _u[0], setUserGroup = _u[1];
    var _v = (0, useLocalStorage_1.useLocalStorage)("lms", "userGroups", (0, exports.getDefaultData)("userGroups", initialValues)), userGroups = _v[0], setUserGroups = _v[1];
    var _w = (0, useLocalStorage_1.useLocalStorage)("lms", "registerableGroups", (0, exports.getDefaultData)("registerableGroups", initialValues)), registerableGroups = _w[0], setRegisterableGroups = _w[1];
    var _x = (0, useLocalStorage_1.useLocalStorage)("lms", "course", (0, exports.getDefaultData)("course", initialValues)), course = _x[0], setCourse = _x[1];
    var _y = (0, useLocalStorage_1.useLocalStorage)("lms", "settings", (0, exports.getDefaultData)("settings", initialValues)), settings = _y[0], setSettings = _y[1];
    var _z = (0, useLocalStorage_1.useLocalStorage)("lms", "config", (0, exports.getDefaultData)("config", initialValues)), config = _z[0], setConfig = _z[1];
    var _0 = (0, useLocalStorage_1.useLocalStorage)("lms", "tags", (0, exports.getDefaultData)("program", initialValues)), program = _0[0], setProgram = _0[1];
    var _1 = (0, useLocalStorage_1.useLocalStorage)("lms", "cart", (0, exports.getDefaultData)("cart", initialValues)), cart = _1[0], setCart = _1[1];
    var _2 = (0, react_1.useState)((0, exports.getDefaultData)("progress", initialValues)), progress = _2[0], setProgress = _2[1];
    var _3 = (0, useLocalStorage_1.useLocalStorage)("lms", "orders", (0, exports.getDefaultData)("orders", initialValues)), orders = _3[0], setOrders = _3[1];
    var _4 = (0, useLocalStorage_1.useLocalStorage)("lms", "payments", (0, exports.getDefaultData)("payments", initialValues)), payments = _4[0], setPayments = _4[1];
    var _5 = (0, useLocalStorage_1.useLocalStorage)("lms", "certificates", (0, exports.getDefaultData)("certificates", initialValues)), certificates = _5[0], setCertificates = _5[1];
    var _6 = (0, useLocalStorage_1.useLocalStorage)("lms", "mattermostChannels", (0, exports.getDefaultData)("mattermostChannels", initialValues)), mattermostChannels = _6[0], setMattermostChannels = _6[1];
    var _7 = (0, react_1.useState)((0, exports.getDefaultData)("tutor", initialValues)), tutor = _7[0], setTutor = _7[1];
    var _8 = (0, useLocalStorage_1.useLocalStorage)("lms", "fontSize", (0, exports.getDefaultData)("fontSize", initialValues)), fontSize = _8[0], setFontSize = _8[1];
    var _9 = (0, useLocalStorage_1.useLocalStorage)("lms", "notifications", (0, exports.getDefaultData)("notifications", initialValues)), notifications = _9[0], setNotifications = _9[1];
    var _10 = (0, useLocalStorage_1.useLocalStorage)("lms", "fields", (0, exports.getDefaultData)("fields", initialValues)), fields = _10[0], setFields = _10[1];
    var _11 = (0, useLocalStorage_1.useLocalStorage)("lms", "stationaryEvents", (0, exports.getDefaultData)("stationaryEvents", initialValues)), stationaryEvents = _11[0], setStationaryEvents = _11[1];
    var _12 = (0, useLocalStorage_1.useLocalStorage)("lms", "stationaryEvent", (0, exports.getDefaultData)("stationaryEvent", initialValues)), stationaryEvent = _12[0], setStationaryEvent = _12[1];
    var _13 = (0, useLocalStorage_1.useLocalStorage)("lms", "userStationaryEvents", (0, exports.getDefaultData)("userStationaryEvents", initialValues)), userStationaryEvents = _13[0], setUserStationaryEvents = _13[1];
    var _14 = (0, useLocalStorage_1.useLocalStorage)("lms", "userWebinars", (0, exports.getDefaultData)("userWebinars", initialValues)), userWebinars = _14[0], setUserWebinars = _14[1];
    var _15 = (0, useLocalStorage_1.useLocalStorage)("lms", "products", (0, exports.getDefaultData)("products", initialValues)), products = _15[0], setProducts = _15[1];
    var _16 = (0, useLocalStorage_1.useLocalStorage)("lms", "product", (0, exports.getDefaultData)("product", initialValues)), product = _16[0], setProduct = _16[1];
    var abortControllers = (0, react_1.useRef)({});
    var fetchConfig = (0, react_1.useCallback)(function () {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "config",
            mode: "value",
            fetchAction: settings_1.config.bind(null, apiUrl)({
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setConfig,
        });
    }, []);
    var fetchSettings = (0, react_1.useCallback)(function () {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "settings",
            mode: "value",
            fetchAction: settings_1.settings.bind(null, apiUrl)({
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setSettings,
        });
    }, []);
    (0, react_1.useEffect)(function () {
        if (initialFetch) {
            fetchSettings();
            fetchConfig();
        }
    }, [initialFetch]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (defaults) {
            defaults.stationaryEvents !== null &&
                setStationaryEvents({
                    loading: false,
                    list: (_a = defaults.stationaryEvents) === null || _a === void 0 ? void 0 : _a.list,
                    error: undefined,
                });
            defaults.events !== null &&
                setEvents({
                    loading: false,
                    list: (_b = defaults.events) === null || _b === void 0 ? void 0 : _b.list,
                    error: undefined,
                });
        }
    }, [defaults]);
    var fetchProducts = (0, react_1.useCallback)(function (filter) {
        var _a;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "products/".concat(JSON.stringify(filter)),
            mode: "paginated",
            fetchAction: products_1.products.bind(null, apiUrl)(filter, {
                signal: (_a = abortControllers.current["products/".concat(JSON.stringify(filter))]) === null || _a === void 0 ? void 0 : _a.signal,
            }),
            setState: setProducts,
        });
    }, []);
    var fetchProduct = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "product".concat(id),
                id: id,
                mode: "value",
                fetchAction: products_1.getSingleProduct.bind(null, apiUrl)(id, token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["product".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setProduct,
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchFields = (0, react_1.useCallback)(function (filter) {
        var _a;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "fields/".concat(JSON.stringify(filter)),
            mode: "list",
            fetchAction: fields_1.fields.bind(null, apiUrl)(filter, {
                signal: (_a = abortControllers.current["fields/".concat(JSON.stringify(filter))]) === null || _a === void 0 ? void 0 : _a.signal,
            }),
            setState: setFields,
        });
    }, []);
    var fetchStationaryEvents = (0, react_1.useCallback)(function (filter) {
        var _a;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "stationaryevents/".concat(JSON.stringify(filter)),
            mode: "list",
            fetchAction: stationary_events_1.stationaryEvents.bind(null, apiUrl)(filter, {
                signal: (_a = abortControllers.current["stationaryevents/".concat(JSON.stringify(filter))]) === null || _a === void 0 ? void 0 : _a.signal,
            }),
            setState: setStationaryEvents,
        });
    }, []);
    var fetchStationaryEvent = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "stationaryevent".concat(id),
            id: id,
            mode: "value",
            fetchAction: stationary_events_1.getStationaryEvent.bind(null, apiUrl)(id, {
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["stationaryevent".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setStationaryEvent,
        });
    }, []);
    var fetchUserWebinars = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "userwebinars",
                mode: "list",
                fetchAction: webinars_1.getMyWebinars.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.userwebinars) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setUserWebinars,
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchUserStationaryEvents = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "userstationaryevents",
                mode: "list",
                fetchAction: stationary_events_1.getMyStationaryEvents.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.userstationaryevents) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setUserStationaryEvents,
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchTutorConsultations = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "tutorconsultation",
                mode: "paginated",
                fetchAction: consultations_1.getTutorConsultations.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.tutorconsultation) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setTutorConsultations,
            })
            : Promise.reject("noToken");
    }, [token]);
    var approveConsultationTerm = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "aprovetutorterm".concat(id),
                mode: "paginated",
                fetchAction: consultations_1.approveConsultation.bind(null, apiUrl)(token, id, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["aprovetutorterm".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setTutorConsultations,
            })
            : Promise.reject("noToken");
    }, [token]);
    var rejectConsultationTerm = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "rejectterm".concat(id),
                mode: "paginated",
                fetchAction: consultations_1.rejectConsultation.bind(null, apiUrl)(token, id, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["rejectterm".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setTutorConsultations,
            })
            : Promise.reject("noToken");
    }, [token]);
    var generateConsultationJitsy = (0, react_1.useCallback)(function (id) {
        return token
            ? consultations_1.generateJitsy.bind(null, apiUrl)(token, id)
            : Promise.reject("noToken");
    }, [token]);
    var generateWebinarJitsy = (0, react_1.useCallback)(function (id) {
        return token
            ? webinars_1.generateJitsyWebinar.bind(null, apiUrl)(token, id)
            : Promise.reject("noToken");
    }, [token]);
    var fetchCertificates = (0, react_1.useCallback)(function (params) {
        var _a;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "certificates/".concat(JSON.stringify(params)),
                mode: "paginated",
                fetchAction: certificates_1.getCertificates.bind(null, apiUrl)(token, params, {
                    signal: (_a = abortControllers.current["certificates/".concat(JSON.stringify(params))]) === null || _a === void 0 ? void 0 : _a.signal,
                }),
                setState: setCertificates,
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchCertificate = (0, react_1.useCallback)(function (id) {
        return token
            ? certificates_1.getCertificate.bind(null, apiUrl)(token, id)
            : Promise.reject("noToken");
    }, [token]);
    var fetchMattermostChannels = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "mattermostchannels",
                mode: "value",
                fetchAction: mattermost_1.getMattermostChannels.bind(null, apiUrl)(token, {}, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.mattermostchannels) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setMattermostChannels,
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchNotifications = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "mattermostchannels",
                mode: "list",
                fetchAction: notify_1.getNotifications.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.mattermostchannels) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setNotifications,
            })
            : Promise.reject("noToken");
    }, [token, notifications]);
    var readNotify = (0, react_1.useCallback)(function (id) {
        return token
            ? notify_1.readNotification
                .bind(null, apiUrl)(id, token)
                .then(function (response) {
                if (response.success) {
                    setNotifications(function (prevState) { return (__assign(__assign({}, prevState), { list: prevState && prevState.list
                            ? prevState.list.filter(function (item) { return item.id !== id; })
                            : [], loading: false })); });
                }
            })
                .catch(function (error) {
                setNotifications(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: error })); });
            })
            : Promise.reject("noToken");
    }, [token, notifications]);
    var changeConsultationTerm = (0, react_1.useCallback)(function (termId, newDate) {
        return token
            ? consultations_1.changeTermDate.bind(null, apiUrl)(termId, newDate, token)
            : Promise.reject("noToken");
    }, [token]);
    var fetchUserConsultations = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "userconsultations",
                mode: "paginated",
                fetchAction: consultations_1.getUserConsultations.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.userconsultations) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setUserConsultations,
            })
            : Promise.reject("noToken");
    }, [token]);
    var bookConsultationTerm = (0, react_1.useCallback)(function (id, term) {
        return token
            ? consultations_1.bookConsultationDate
                .bind(null, apiUrl)(token, id, term)
                .then(function (response) {
                if (response.success) {
                    fetchUserConsultations();
                    return response;
                }
                throw Error("Error occured");
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchConsultation = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            id: id,
            controllers: abortControllers.current,
            controller: "consultation".concat(id),
            mode: "value",
            fetchAction: consultations_1.getConsultation.bind(null, apiUrl)(id, {
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["consultation".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setConsultation,
        });
    }, []);
    var getProductInfo = (0, react_1.useCallback)(function (id) {
        return token
            ? products_1.getSingleProduct.bind(null, apiUrl)(id, token)
            : Promise.reject("noToken");
    }, [token]);
    var fetchEvents = (0, react_1.useCallback)(function (filter) {
        var _a;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "events/".concat(JSON.stringify(filter)),
            mode: "paginated",
            fetchAction: events_1.events.bind(null, apiUrl)(filter, {
                signal: (_a = abortControllers.current["events/".concat(JSON.stringify(filter))]) === null || _a === void 0 ? void 0 : _a.signal,
            }),
            setState: setEvents,
        });
    }, []);
    var fetchUserGroup = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "usergroup".concat(id),
            id: id,
            mode: "value",
            fetchAction: user_groups_1.userGroup.bind(null, apiUrl)(id, {
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["usergroup".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setUserGroup,
        });
    }, []);
    var fetchRegisterableGroups = (0, react_1.useCallback)(function () {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "registablegroups",
            mode: "list",
            fetchAction: user_groups_1.registerableGroups.bind(null, apiUrl)({
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.registablegroups) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setRegisterableGroups,
        });
    }, []);
    var fetchUserGroups = (0, react_1.useCallback)(function (params) {
        var _a;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "getusergroups/".concat(JSON.stringify(params)),
            mode: "paginated",
            fetchAction: user_groups_1.userGroups.bind(null, apiUrl)(params, {
                signal: (_a = abortControllers.current["getusergroups/".concat(JSON.stringify(params))]) === null || _a === void 0 ? void 0 : _a.signal,
            }),
            setState: setUserGroups,
        });
    }, []);
    var fetchCourse = (0, react_1.useCallback)(function (id) {
        setCourse(function (prevState) {
            var _a, _b;
            return (__assign(__assign({}, prevState), { loading: true, byId: prevState.byId
                    ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id] = __assign(__assign({}, prevState.byId[id]), { loading: true }), _a)) : (_b = {}, _b[id] = { loading: true }, _b) }));
        });
        return courses_2.getCourse
            .bind(null, apiUrl)(id)
            .then(function (response) {
            if (response.success) {
                var lessons_1 = (0, exports.sortProgram)(response.data.lessons || []);
                setCourse(function (prevState) {
                    var _a, _b;
                    return ({
                        loading: false,
                        value: __assign(__assign({}, response.data), { lessons: lessons_1 }),
                        byId: prevState.byId
                            ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id] = {
                                value: response.data,
                                loading: false,
                            }, _a)) : (_b = {},
                            _b[id] = {
                                value: response.data,
                                loading: false,
                            },
                            _b),
                    });
                });
            }
            if (response.success === false) {
                setCourse(function (prevState) {
                    var _a, _b;
                    return (__assign(__assign({}, prevState), { loading: false, error: response, byId: prevState.byId
                            ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id] = {
                                error: response,
                                loading: false,
                            }, _a)) : (_b = {},
                            _b[id] = {
                                error: response,
                                loading: false,
                            },
                            _b) }));
                });
            }
        });
    }, []);
    var resetState = (0, react_1.useCallback)(function () {
        logoutUser();
        setProgram(defaults_1.defaultConfig.program);
        setCart(defaults_1.defaultConfig.cart);
        setCertificates(defaults_1.defaultConfig.certificates);
        setNotifications(defaults_1.defaultConfig.notifications);
        setMattermostChannels(defaults_1.defaultConfig.mattermostChannels);
    }, [logoutUser]);
    var logout = (0, react_1.useCallback)(function () {
        // TODO this should be composition of contexts
        // API Call here to destroy token
        resetState();
        return Promise.resolve();
    }, []);
    var fetchQuestionnaires = (0, react_1.useCallback)(function (model, id) {
        return token
            ? questionnaire_1.getQuestionnaires.bind(null, apiUrl)(token, model, id)
            : Promise.reject("noToken");
    }, [token]);
    var sendQuestionnaireAnswer = (0, react_1.useCallback)(function (model, modelID, id, body) {
        return token
            ? questionnaire_1.questionnaireAnswer.bind(null, apiUrl)(token, model, modelID, id, body)
            : Promise.reject("noToken");
    }, [token]);
    var fetchCart = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "cart",
                mode: "value",
                fetchAction: cart_1.cart.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.cart) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setCart,
            })
            : Promise.reject("noToken");
    }, [token]);
    var addToCart = (0, react_1.useCallback)(function (productId, quantity) {
        if (!token) {
            return Promise.reject("noToken");
        }
        setCart(function (prevState) { return (__assign(__assign({}, prevState), { loading: true })); });
        return cart_1.addToCart
            .bind(null, apiUrl)(productId, token, quantity)
            .then(function () {
            fetchCart();
        })
            .catch(function (error) {
            setCart(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: error.data })); });
        });
    }, [fetchCart]);
    var addMissingProducts = (0, react_1.useCallback)(function (products) {
        if (!token) {
            return Promise.reject("noToken");
        }
        setCart(function (prevState) { return (__assign(__assign({}, prevState), { loading: true })); });
        return cart_1.addMissingProducts
            .bind(null, apiUrl)(token, products)
            .then(function () {
            fetchCart();
        })
            .catch(function (error) {
            setCart(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: error.data })); });
        });
    }, [fetchCart]);
    var removeFromCart = (0, react_1.useCallback)(function (itemId) {
        if (!token) {
            return Promise.reject("noToken");
        }
        setCart(function (prevState) { return (__assign(__assign({}, prevState), { loading: true })); });
        return cart_1.removeFromCart
            .bind(null, apiUrl)(itemId, token)
            .then(function (response) {
            setCart(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, value: __assign(__assign({}, prevState.value), { items: prevState && prevState.value
                        ? prevState.value.items.filter(function (item) { return item.id !== itemId; })
                        : [] }) })); });
            fetchCart();
        })
            .catch(function (error) {
            setCart(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: error.data })); });
        });
    }, [fetchCart]);
    var payWithStripe = (0, react_1.useCallback)(function (payment_method, return_url) {
        return token
            ? cart_1.payWithStripe
                .bind(null, apiUrl)(payment_method, return_url, token)
                .then(function (res) {
                console.log(res);
            })
            : Promise.reject("noToken");
    }, [token]);
    var payWithP24 = (0, react_1.useCallback)(function (email, return_url, data) {
        return token
            ? cart_1.payWithP24
                .bind(null, apiUrl)(email, return_url, token, data)
                .then(function (res) {
                return res;
            })
                .catch(function (err) {
                console.log(err);
                return err;
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchOrderInvoice = (0, react_1.useCallback)(function (id) {
        return token
            ? cart_1.orderInvoice.bind(null, apiUrl)(token, id)
            : Promise.reject("noToken");
    }, [token]);
    var fetchProgram = (0, react_1.useCallback)(function (id) {
        setProgram(function (prevState) { return (__assign(__assign({}, prevState), { loading: true })); });
        return courses_2.getCourseProgram
            .bind(null, apiUrl)(id, token)
            .then(function (response) {
            if (response.success) {
                setProgram({
                    loading: false,
                    value: __assign(__assign({}, response.data), { lessons: (0, exports.sortProgram)(response.data.lessons) }),
                });
            }
            if (response.success === false) {
                setProgram(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: response })); });
            }
        })
            .catch(function (error) {
            setProgram(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: error.data })); });
        });
    }, [token]);
    var fetchProgress = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "progress",
                mode: "value",
                fetchAction: courses_2.progress.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.progress) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setProgress,
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchTutor = (0, react_1.useCallback)(function (id) {
        var _a, _b;
        return (0, states_1.fetchDataType)({
            controllers: abortControllers.current,
            controller: "tutor".concat(id),
            id: id,
            mode: "value",
            fetchAction: courses_2.tutor.bind(null, apiUrl)(id, {
                signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a["tutor".concat(id)]) === null || _b === void 0 ? void 0 : _b.signal,
            }),
            setState: setTutor,
        });
    }, [token]);
    var fetchOrders = (0, react_1.useCallback)(function (params) {
        var _a;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "orders/".concat(JSON.stringify(params)),
                mode: "paginated",
                fetchAction: cart_1.orders.bind(null, apiUrl)(token, params, {
                    signal: (_a = abortControllers.current["orders/".concat(JSON.stringify(params))]) === null || _a === void 0 ? void 0 : _a.signal,
                }),
                setState: setOrders,
            })
            : Promise.reject("noToken");
    }, [token]);
    var fetchPayments = (0, react_1.useCallback)(function () {
        var _a, _b;
        return token
            ? (0, states_1.fetchDataType)({
                controllers: abortControllers.current,
                controller: "payments",
                mode: "paginated",
                fetchAction: cart_1.payments.bind(null, apiUrl)(token, {
                    signal: (_b = (_a = abortControllers.current) === null || _a === void 0 ? void 0 : _a.payments) === null || _b === void 0 ? void 0 : _b.signal,
                }),
                setState: setPayments,
            })
            : Promise.reject("noToken");
    }, [token]);
    var sendProgress = (0, react_1.useCallback)(function (courseId, data) {
        return token
            ? courses_2.sendProgress
                .bind(null, apiUrl)(courseId, data, token)
                .then(function (res) {
                setProgress(function (prevState) { return (__assign(__assign({}, prevState), { value: prevState && prevState.value
                        ? prevState.value.map(function (courseProgress) {
                            if (courseProgress.course.id === courseId) {
                                return __assign(__assign({}, courseProgress), { progress: courseProgress.progress.map(function (progress) {
                                        var el = data.find(function (item) { return item.topic_id === progress.topic_id; });
                                        if (el) {
                                            return el;
                                        }
                                        return progress;
                                    }) });
                            }
                            return courseProgress;
                        })
                        : [] })); });
            })
            : Promise.reject("noToken");
    }, [token]);
    var h5pProgress = (0, react_1.useCallback)(function (courseId, topicId, statement) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var statementId = (_a = statement === null || statement === void 0 ? void 0 : statement.verb) === null || _a === void 0 ? void 0 : _a.id;
        var statementCategory = (_c = (_b = statement === null || statement === void 0 ? void 0 : statement.context) === null || _b === void 0 ? void 0 : _b.contextActivities) === null || _c === void 0 ? void 0 : _c.category;
        var result = statement === null || statement === void 0 ? void 0 : statement.result;
        var hasParent = ((_e = (_d = statement === null || statement === void 0 ? void 0 : statement.context) === null || _d === void 0 ? void 0 : _d.contextActivities) === null || _e === void 0 ? void 0 : _e.parent) &&
            ((_h = (_g = (_f = statement === null || statement === void 0 ? void 0 : statement.context) === null || _f === void 0 ? void 0 : _f.contextActivities) === null || _g === void 0 ? void 0 : _g.parent) === null || _h === void 0 ? void 0 : _h.length) > 0;
        if (defaults_1.attempted === statementId &&
            statementCategory &&
            statementCategory[0].id.includes(defaults_1.guessTheAnswer)) {
            sendProgress(Number(courseId), [
                {
                    topic_id: topicId,
                    status: 1,
                },
            ]);
        }
        if (defaults_1.blackList.includes(statementId)) {
            return null;
        }
        if (defaults_1.completed.includes(statementId)) {
            if ((!hasParent &&
                statementCategory &&
                !((_j = statementCategory[0]) === null || _j === void 0 ? void 0 : _j.id.includes(defaults_1.questionSet))) ||
                (statementCategory &&
                    ((_k = statementCategory[0]) === null || _k === void 0 ? void 0 : _k.id.includes(defaults_1.questionSet)) &&
                    result &&
                    ((_l = result === null || result === void 0 ? void 0 : result.score) === null || _l === void 0 ? void 0 : _l.max) === ((_m = result === null || result === void 0 ? void 0 : result.score) === null || _m === void 0 ? void 0 : _m.raw))) {
                sendProgress(Number(courseId), [
                    {
                        topic_id: topicId,
                        status: 1,
                    },
                ]);
            }
        }
        return token
            ? courses_2.h5pProgress.bind(null, apiUrl)(topicId, statementId, statement, token)
            : null;
    }, [token]);
    var topicPing = (0, react_1.useCallback)(function (topicId) {
        return token
            ? courses_2.topicPing
                .bind(null, apiUrl)(topicId, token)
                .catch(function (err) { return err; })
            : Promise.reject("noToken");
    }, [token]);
    var progressMap = (0, react_1.useMemo)(function () {
        var defaultMap = {
            coursesProcProgress: {},
            finishedTopics: [],
        };
        if (progress.value) {
            progress.value.reduce(function (acc, course) {
                acc.coursesProcProgress[typeof course.course.id === "number" ? course.course.id : 0] =
                    course.progress.reduce(function (sum, item) { return sum + item.status; }, 0) /
                        course.progress.length;
                acc.finishedTopics = acc.finishedTopics.concat(course.progress
                    .filter(function (item) { return item.status !== 0; })
                    .map(function (item) { return item.topic_id; }));
                return acc;
            }, defaultMap);
        }
        return defaultMap;
    }, [progress]);
    var topicIsFinished = (0, react_1.useCallback)(function (topicId) {
        return progressMap && progressMap.finishedTopics.includes(topicId);
    }, [progressMap]);
    var courseProgress = (0, react_1.useCallback)(function (courseId) {
        return progressMap && progressMap.coursesProcProgress[courseId]
            ? progressMap.coursesProcProgress[courseId]
            : 0;
    }, [progressMap]);
    var getNextPrevTopic = (0, react_1.useCallback)(function (topicId, next) {
        var _a, _b;
        if (next === void 0) { next = true; }
        var lesson = (_a = program.value) === null || _a === void 0 ? void 0 : _a.lessons.find(function (lesson) { var _a; return !!((_a = lesson.topics) === null || _a === void 0 ? void 0 : _a.find(function (topic) { return topicId === topic.id; })); });
        if (program.value === undefined) {
            return null;
        }
        if (!lesson) {
            return null;
        }
        var currentLessonIndex = program.value.lessons.findIndex(function (fLesson) { return lesson.id === fLesson.id; });
        if (currentLessonIndex === undefined) {
            return null;
        }
        var currentTopicIndex = (_b = (program.value && program.value.lessons ? program.value.lessons : [])[currentLessonIndex].topics) === null || _b === void 0 ? void 0 : _b.findIndex(function (topic) { return Number(topic.id) === Number(topicId); });
        if (currentTopicIndex === undefined) {
            return null;
        }
        var topics = program.value.lessons[currentLessonIndex].topics;
        if (next) {
            if (Array.isArray(topics) && topics[currentTopicIndex + 1]) {
                return topics[currentTopicIndex + 1] || null;
            }
            else {
                if (program.value.lessons[currentLessonIndex + 1]) {
                    var newLesson = program.value.lessons[currentLessonIndex + 1];
                    return (newLesson.topics && newLesson.topics[0]) || null;
                }
            }
        }
        else {
            if (Array.isArray(topics) && topics[currentTopicIndex - 1]) {
                return topics[currentTopicIndex - 1] || null;
            }
            else {
                if (program.value.lessons[currentLessonIndex - 1]) {
                    var newLesson = program.value.lessons[currentLessonIndex - 1];
                    return ((newLesson.topics &&
                        newLesson.topics[newLesson.topics.length - 1]) ||
                        null);
                }
            }
        }
        return null;
    }, [program]);
    var fontSizeToggle = (0, react_1.useCallback)(function (bigger) {
        var newFontSize = (fontSize + (bigger ? 1 : -1)) % 4;
        return setFontSize(newFontSize);
    }, [fontSize]);
    var realizeVoucher = (0, react_1.useCallback)(function (voucher) {
        return token
            ? cart_1.useVoucher.bind(null, apiUrl)(voucher, token)
            : Promise.reject("noToken");
    }, [token]);
    return ((0, jsx_runtime_1.jsx)(exports.EscolaLMSContext.Provider, __assign({ value: {
            apiUrl: apiUrl,
            courses: courses,
            course: course,
            program: program,
            fetchCourses: fetchCourses,
            fetchCourse: fetchCourse,
            fetchProgram: fetchProgram,
            fetchSettings: fetchSettings,
            settings: settings,
            config: config,
            fetchConfig: fetchConfig,
            fetchTags: fetchTags,
            uniqueTags: uniqueTags,
            fetchCategories: fetchCategories,
            categoryTree: categoryTree,
            login: login,
            logout: logout,
            forgot: forgot,
            reset: reset,
            user: user,
            register: register,
            fetchCart: fetchCart,
            addToCart: addToCart,
            removeFromCart: removeFromCart,
            cart: cart,
            payWithStripe: payWithStripe,
            fetchProgress: fetchProgress,
            progress: progress,
            sendProgress: sendProgress,
            fetchTutors: fetchTutors,
            tutors: tutors,
            fetchTutor: fetchTutor,
            tutor: tutor,
            fetchOrders: fetchOrders,
            orders: orders,
            fetchPayments: fetchPayments,
            payments: payments,
            pages: pages,
            fetchPages: fetchPages,
            page: page,
            fetchPage: fetchPage,
            fetchProfile: fetchProfile,
            updateProfile: updateProfile,
            updateAvatar: updateAvatar,
            topicPing: topicPing,
            topicIsFinished: topicIsFinished,
            courseProgress: courseProgress,
            getNextPrevTopic: getNextPrevTopic,
            fontSize: fontSize,
            fontSizeToggle: fontSizeToggle,
            h5pProgress: h5pProgress,
            userGroups: userGroups,
            fetchUserGroups: fetchUserGroups,
            userGroup: userGroup,
            fetchUserGroup: fetchUserGroup,
            registerableGroups: registerableGroups,
            fetchRegisterableGroups: fetchRegisterableGroups,
            socialAuthorize: socialAuthorize,
            notifications: notifications,
            fetchNotifications: fetchNotifications,
            readNotify: readNotify,
            certificates: certificates,
            fetchCertificates: fetchCertificates,
            fetchCertificate: fetchCertificate,
            mattermostChannels: mattermostChannels,
            fetchMattermostChannels: fetchMattermostChannels,
            h5p: h5p,
            fetchH5P: fetchH5P,
            emailVerify: emailVerify,
            getRefreshedToken: getRefreshedToken,
            tokenExpireDate: tokenExpireDate,
            fetchConsultations: fetchConsultations,
            consultations: consultations,
            consultation: consultation,
            fetchConsultation: fetchConsultation,
            fields: fields,
            fetchFields: fetchFields,
            stationaryEvents: stationaryEvents,
            fetchStationaryEvents: fetchStationaryEvents,
            fetchStationaryEvent: fetchStationaryEvent,
            fetchUserConsultations: fetchUserConsultations,
            userConsultations: userConsultations,
            bookConsultationTerm: bookConsultationTerm,
            fetchWebinars: fetchWebinars,
            fetchWebinar: fetchWebinar,
            webinars: webinars,
            payWithP24: payWithP24,
            getProductInfo: getProductInfo,
            fetchTutorConsultations: fetchTutorConsultations,
            approveConsultationTerm: approveConsultationTerm,
            generateConsultationJitsy: generateConsultationJitsy,
            rejectConsultationTerm: rejectConsultationTerm,
            tutorConsultations: tutorConsultations,
            fetchEvents: fetchEvents,
            events: events,
            changePassword: changePassword,
            stationaryEvent: stationaryEvent,
            webinar: webinar,
            userWebinars: userWebinars,
            fetchUserWebinars: fetchUserWebinars,
            generateWebinarJitsy: generateWebinarJitsy,
            realizeVoucher: realizeVoucher,
            products: products,
            product: product,
            fetchQuestionnaires: fetchQuestionnaires,
            sendQuestionnaireAnswer: sendQuestionnaireAnswer,
            fetchUserStationaryEvents: fetchUserStationaryEvents,
            userStationaryEvents: userStationaryEvents,
            fetchOrderInvoice: fetchOrderInvoice,
            addMissingProducts: addMissingProducts,
            getImagePrefix: getImagePrefix,
            changeConsultationTerm: changeConsultationTerm,
            fetchProducts: fetchProducts,
            fetchProduct: fetchProduct,
        } }, { children: children })));
};
var EscolaLMSContextProvider = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var contextProps = { defaults: props.defaults, apiUrl: props.apiUrl };
    return ((0, jsx_runtime_1.jsx)(user_1.UserContextProvider, __assign({}, contextProps, { children: (0, jsx_runtime_1.jsx)(courses_3.CoursesContextProvider, __assign({}, contextProps, { children: (0, jsx_runtime_1.jsx)(categories_1.CategoriesContextProvider, __assign({}, contextProps, { children: (0, jsx_runtime_1.jsx)(tags_1.TagsContextProvider, __assign({}, contextProps, { children: (0, jsx_runtime_1.jsx)(tutors_1.TutorsContextProvider, __assign({}, contextProps, { children: (0, jsx_runtime_1.jsx)(webinars_2.WebinarsContextProvider, __assign({}, contextProps, { children: (0, jsx_runtime_1.jsx)(webinar_1.WebinarContextProvider, __assign({}, contextProps, { children: (0, jsx_runtime_1.jsx)(h5p_1.H5pContextProvider, __assign({}, contextProps, { children: (0, jsx_runtime_1.jsx)(consultations_2.ConsultationsContextProvider, __assign({}, contextProps, { children: (0, jsx_runtime_1.jsx)(pages_1.PagesContextProvider, __assign({}, contextProps, { children: (0, jsx_runtime_1.jsx)(page_1.PageContextProvider, __assign({}, contextProps, { children: (0, jsx_runtime_1.jsx)(EscolaLMSContextProviderInner, __assign({}, props, { children: children })) })) })) })) })) })) })) })) })) })) })) })));
};
exports.EscolaLMSContextProvider = EscolaLMSContextProvider;
